/**
 * Glass surfaces aligned with the Company page (founder section + StatTiles).
 */
export const SITE_GLASS_CARD =
  'overflow-hidden rounded-3xl border border-white/[0.08] bg-[var(--home-zone-dark)]/50 shadow-[0_48px_100px_-50px_rgb(0_0_0/0.85)] ring-1 ring-white/[0.04] backdrop-blur-sm';

/** KPIs / nested panels — Company StatTile recipe */
export const SITE_GLASS_TILE =
  'rounded-2xl border border-white/[0.08] bg-[var(--home-zone-dark)]/50 ring-1 ring-white/[0.04] backdrop-blur-sm';

/** Admin CRM / dossiers — readable on busy marketing backdrops */
export const SITE_GLASS_PANEL =
  'overflow-hidden rounded-3xl border border-white/[0.12] bg-[var(--home-zone-dark)]/82 shadow-[0_28px_70px_-40px_rgba(0,0,0/0.55)] ring-1 ring-white/[0.08] backdrop-blur-md';

/**
 * Unified shell for drip tab bar + all primary section cards (Dashboard, Campaigns, Templates, Settings).
 * Slightly higher fill + blur than `SITE_GLASS_CARD` so large surfaces match the tab rail and read less “green” over the turf.
 */
const SITE_DRIP_ADMIN_NAV_MATCH =
  'border border-white/[0.08] bg-[var(--home-zone-dark)]/58 shadow-[0_48px_100px_-50px_rgb(0_0_0/0.85)] ring-1 ring-white/[0.04] backdrop-blur-md';

/** Drip tab rail — same glass as primary drip cards. */
export const SITE_DRIP_TABBAR = `overflow-hidden rounded-2xl ${SITE_DRIP_ADMIN_NAV_MATCH}`;

/** Drip primary page sections (dashboard, campaigns, templates, settings cards). */
export const SITE_DRIP_SURFACE = `overflow-hidden rounded-2xl ${SITE_DRIP_ADMIN_NAV_MATCH}`;

/** Nested column panels (e.g. workflow builder columns). */
export const SITE_DRIP_PANEL = `overflow-hidden rounded-2xl ${SITE_DRIP_ADMIN_NAV_MATCH}`;

/** Nested rows / inset panels — same hue as shells; neutral darken (no white frost). */
export const SITE_DRIP_INNER =
  'rounded-xl border border-white/[0.08] bg-black/22 ring-1 ring-white/[0.06] backdrop-blur-sm';

/**
 * Native `<select>` option rows — dropdown surfaces are often light (system UI); force readable option rows.
 * Include `optgroup` descendants for grouped selects.
 */
export const SITE_SELECT_OPTIONS =
  '[&>option]:bg-white [&>option]:text-neutral-900 [&>option]:font-medium [&_optgroup_option]:bg-white [&_optgroup_option]:text-neutral-900';

/** Form controls: frosted inset on glass (Company SnapshotStat / compliance-panel language) */
export const SITE_FORM_CONTROL =
  'rounded-xl border border-white/12 bg-white/[0.08] px-3 py-2 text-sm text-[var(--home-text-on-dark)] placeholder:text-[var(--home-muted-on-dark)] shadow-inner shadow-black/25 backdrop-blur-sm outline-none focus:border-[var(--home-miami-blue)] focus:ring-2 focus:ring-[var(--home-miami-blue)]/30';

/** `<input type="file">` — same frosted track + “Choose file” button as Company / admin glass */
export const SITE_FILE_CONTROL = `${SITE_FORM_CONTROL} file:mr-3 file:rounded-lg file:border file:border-white/12 file:bg-white/[0.12] file:px-3 file:py-1.5 file:text-sm file:text-[var(--home-text-on-dark)] file:shadow-inner file:shadow-black/20 file:backdrop-blur-sm`;
